import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => {
  return {
    callout: {
      flexGrow: 1,
    },
    searchAreaContainer: {
      maxHeight: 400,
      padding: 10,
    },
  };
});
